// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"161":"__federation_expose_EmployeeManagement","681":"__federation_expose_CustomerManagement","878":"__federation_expose_MessageApp"}[chunkId] + "." + {"161":"1bfb8462","681":"53cb4ca1","878":"44fcc093"}[chunkId] + ".chunk.css";
};